import React, { useEffect, useMemo, useState } from "react";
import { Tooltip } from "antd";
import { FaExclamationCircle } from "react-icons/fa";
import { availableCountries } from "../../helpers/OrdersFunctionsGlobal";

function ClientInfoComponent({
  client,
  customer,
  note_from_client = "",
  shipping_address,
  commentOverWeight,
  order_shop = {},
  item = {},
}) {
  const [checkPaymentMethod, setCheckPaymentMethod] = useState(false);
  useEffect(() => {
    if (
      item?.carrier?.module_name === "upickupatstore" &&
      item?.is_without_vat === true &&
      item?.payment_module === "cashondelivery" &&
      item?.order_shop_id === 7
    ) {
      setCheckPaymentMethod(true);
    }
  }, []);

  const available_country = useMemo(() => {
    if (!shipping_address) return false;
    if (!shipping_address?.country_id) return false;
    if (!order_shop?.country_id) return false;
    return availableCountries(
      shipping_address.country_id,
      order_shop?.country_id
    );
  }, [shipping_address]);
  return (
    <div>
      {customer?.rline && (
        <span style={{ fontSize: "0.8rem", fontWeight: "900" }}>
          <span className="text-danger">[R-Line]:</span>
          {customer.rline_code} - {customer.consultant_code}
          <br />
        </span>
      )}
      <span className="font-weight-bold">
        {client?.contact_person ?? client.firstname + " " + client.lastname}
      </span>
      <br />
      {client.company && (
        <>
          <span style={{ fontSize: "0.6rem" }}>{client.company}</span>
          <br />
        </>
      )}
      {client.company_code && (
        <>
          <span style={{ fontSize: "0.55rem" }}>
            Įm. kodas: {client.company_code}
          </span>
          <br />
        </>
      )}
      {client.vat_code && (
        <>
          <span style={{ fontSize: "0.55rem" }}>PVM: {client.vat_code}</span>
          <br />
        </>
      )}
      <span style={{ fontSize: "0.6rem" }}>
        {client.email && <div>{client.email}</div>}
        {client.other && <div>{client.other}</div>}
        {client.phone}
      </span>
      <div
        className="d-flex flex-column"
        style={{
          gap: 3,
        }}
      >
        {note_from_client && (
          <Tooltip
            placement="rightBottom"
            overlayClassName="tooltip-white"
            title={
              <div className="px-2 py-1">
                <h3 className="text-xs font-semi-bold text-black mb-1">
                  Client comment
                </h3>
                <p className="text-xs text-black mb-0">{note_from_client}</p>
              </div>
            }
          >
            <FaExclamationCircle
              className="text-info"
              style={{
                width: 30,
                height: 30,
              }}
            />
          </Tooltip>
        )}
        {(!available_country || checkPaymentMethod) && (
          <Tooltip
            placement="rightBottom"
            overlayClassName="tooltip-white"
            popupVisible={true}
            title={
              <div className="px-2 py-1">
                {!available_country && (
                  <>
                    <h3 className="text-xs font-semi-bold text-black mb-1">
                      Please check delivery country
                    </h3>
                    <p className="text-xs text-black mb-0">
                      The country of delivery does not match the country of the
                      stores
                      {/* Delivery address is not Lithuania, Latvia, Estonia or Finland */}
                    </p>
                  </>
                )}
                {!available_country && checkPaymentMethod && <hr />}
                {checkPaymentMethod && (
                  <>
                    <h3 className="text-xs font-semi-bold text-black mb-1">
                      Wrong payment method
                    </h3>
                    <p className="text-xs text-black mb-0">
                      Call the customer back, change the payment method
                      {/* If compantu and pickup in office*/}
                    </p>
                  </>
                )}
              </div>
            }
          >
            <FaExclamationCircle
              color="#DC3545"
              style={{
                width: 30,
                height: 30,
              }}
            />
          </Tooltip>
        )}
        {commentOverWeight && (
          <Tooltip
            placement="rightBottom"
            overlayClassName="tooltip-white"
            title={
              <div className="px-2 py-1">
                <h3 className="text-xs font-semi-bold text-black mb-1">
                  AutoSys
                </h3>
                <p className="text-xs text-black mb-0">
                  An attempt was made to assign autosys with carrying weight is
                  more when 80kg.
                </p>
              </div>
            }
          >
            <FaExclamationCircle
              color="#f0a22c"
              style={{
                width: 30,
                height: 30,
              }}
            />
          </Tooltip>
        )}
      </div>
    </div>
  );
}

export default ClientInfoComponent;
